import { createContext } from 'react';
export var AccordionContext = /*#__PURE__*/createContext({});